const retrieveContent = async () => {
    const response = await fetch(process.env.REACT_APP_PRODUCTION_SERVER_ENDPOINT + '/fetch-content');
    const data = await response.json();

    return data.data;
};

export default retrieveContent;